export interface DublinCommuterMatrixEntry {
  slug: string;
  town: string;
  county: string;
  dublinRentAvg: number;
  townRentAvg: number;
  commuteMinutesOneWay: number;
  commuteCostMonthly: number;
  primaryMode: string;
  fareSystem: string;
  lastServiceFromDublin: string;
  taxSaverEligible: boolean;
  propertyTypeMatch: string;
}

export const DUBLIN_RENT_REFERENCE_2026 = 2350;

export const DUBLIN_COMMUTER_MATRIX_2026: DublinCommuterMatrixEntry[] = [
  {
    slug: 'naas',
    town: 'Naas',
    county: 'Kildare',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1650,
    commuteMinutesOneWay: 45,
    commuteCostMonthly: 125,
    primaryMode: 'Train + feeder bus',
    fareSystem: 'Leap commuter fare',
    lastServiceFromDublin: '23:20',
    taxSaverEligible: true,
    propertyTypeMatch: '2-bed apartment with parking',
  },
  {
    slug: 'drogheda',
    town: 'Drogheda',
    county: 'Louth',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1500,
    commuteMinutesOneWay: 55,
    commuteCostMonthly: 145,
    primaryMode: 'Rail',
    fareSystem: 'TaxSaver intercity commuter',
    lastServiceFromDublin: '23:10',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed semi-D with garden',
  },
  {
    slug: 'bray',
    town: 'Bray',
    county: 'Wicklow',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1950,
    commuteMinutesOneWay: 40,
    commuteCostMonthly: 96,
    primaryMode: 'DART',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:45',
    taxSaverEligible: false,
    propertyTypeMatch: 'large 1-bed near seafront',
  },
  {
    slug: 'navan',
    town: 'Navan',
    county: 'Meath',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1450,
    commuteMinutesOneWay: 65,
    commuteCostMonthly: 160,
    primaryMode: 'Express bus / car mix',
    fareSystem: 'Fuel + bus blended cost',
    lastServiceFromDublin: '23:30',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed semi-D with driveway and garden',
  },
  {
    slug: 'maynooth',
    town: 'Maynooth',
    county: 'Kildare',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1850,
    commuteMinutesOneWay: 45,
    commuteCostMonthly: 96,
    primaryMode: 'Rail',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:35',
    taxSaverEligible: true,
    propertyTypeMatch: '2-bed duplex in a newer estate',
  },
  {
    slug: 'leixlip',
    town: 'Leixlip',
    county: 'Kildare',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1900,
    commuteMinutesOneWay: 30,
    commuteCostMonthly: 96,
    primaryMode: 'Rail',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:45',
    taxSaverEligible: true,
    propertyTypeMatch: '2-bed apartment near train station',
  },
  {
    slug: 'celbridge',
    town: 'Celbridge',
    county: 'Kildare',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1750,
    commuteMinutesOneWay: 40,
    commuteCostMonthly: 110,
    primaryMode: 'Bus',
    fareSystem: 'Leap commuter bus',
    lastServiceFromDublin: '23:30',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed terraced house with garden',
  },
  {
    slug: 'swords',
    town: 'Swords',
    county: 'Fingal',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 2100,
    commuteMinutesOneWay: 25,
    commuteCostMonthly: 96,
    primaryMode: 'Bus / MetroLink (future)',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '00:15',
    taxSaverEligible: false,
    propertyTypeMatch: '2-bed apartment in modern development',
  },
  {
    slug: 'malahide',
    town: 'Malahide',
    county: 'Fingal',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 2200,
    commuteMinutesOneWay: 30,
    commuteCostMonthly: 96,
    primaryMode: 'DART',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:50',
    taxSaverEligible: false,
    propertyTypeMatch: '2-bed house near village center',
  },
  {
    slug: 'greystones',
    town: 'Greystones',
    county: 'Wicklow',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 2000,
    commuteMinutesOneWay: 50,
    commuteCostMonthly: 96,
    primaryMode: 'DART',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:30',
    taxSaverEligible: false,
    propertyTypeMatch: '2-bed house with sea views',
  },
  {
    slug: 'dundalk',
    town: 'Dundalk',
    county: 'Louth',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1400,
    commuteMinutesOneWay: 70,
    commuteCostMonthly: 165,
    primaryMode: 'Enterprise rail',
    fareSystem: 'TaxSaver intercity commuter',
    lastServiceFromDublin: '22:45',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed house with large garden',
  },
  {
    slug: 'ratoath',
    town: 'Ratoath',
    county: 'Meath',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1650,
    commuteMinutesOneWay: 35,
    commuteCostMonthly: 120,
    primaryMode: 'Bus / M3 car',
    fareSystem: 'Leap commuter bus + fuel',
    lastServiceFromDublin: '23:15',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed semi-D in newer estate',
  },
  {
    slug: 'dunboyne',
    town: 'Dunboyne',
    county: 'Meath',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1750,
    commuteMinutesOneWay: 30,
    commuteCostMonthly: 110,
    primaryMode: 'Bus / M3 car',
    fareSystem: 'Leap commuter bus + fuel',
    lastServiceFromDublin: '23:30',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed terraced house',
  },
  {
    slug: 'kilcock',
    town: 'Kilcock',
    county: 'Kildare',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 1550,
    commuteMinutesOneWay: 50,
    commuteCostMonthly: 130,
    primaryMode: 'Rail',
    fareSystem: 'TaxSaver commuter rail',
    lastServiceFromDublin: '23:20',
    taxSaverEligible: true,
    propertyTypeMatch: '3-bed semi-D with garden',
  },
  {
    slug: 'portmarnock',
    town: 'Portmarnock',
    county: 'Fingal',
    dublinRentAvg: DUBLIN_RENT_REFERENCE_2026,
    townRentAvg: 2150,
    commuteMinutesOneWay: 25,
    commuteCostMonthly: 96,
    primaryMode: 'DART / Bus',
    fareSystem: 'TFI fare cap',
    lastServiceFromDublin: '23:45',
    taxSaverEligible: false,
    propertyTypeMatch: '2-bed apartment near beach',
  },
];
